import type { TFunction } from 'i18next'

import { SECTION_STATUSES } from '../constants/section-status'

export const getSectionStatusOptions = (t: TFunction<'sections'>) =>
  SECTION_STATUSES.map(status => ({
    value: status,
    label: t(`status.${status}`)
  }))
